module.exports = __webpack_public_path__ + "static/img/bg-ar.77b40458.png";